import Request from "../request";
const request = new Request();

export class PromotionService {
  static list = async (
    promoCode: string,
    sort: string,
    search: string,
    recommendCode: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    let params = "";

    if (promoCode) {
      params += `promoCode=${promoCode}&`;
    }
    if (sort) {
      params += `sort=${sort}&`;
    }
    if (search) {
      params += `search=${search}&`;
    }
    if (startDate) {
      params += `startDate=${startDate}&`;
    }
    if (endDate) {
      params += `endDate=${endDate}&`;
    }
    if (limit) {
      params += `limit=${limit}&`;
    }
    if (page) {
      params += `page=${page}&`;
    }
    if (recommendCode) {
      params += `recommendCode=${recommendCode}&`;
    }

    const { data } = await request.get(
      "/admin/promotion" + (params ? "?" + params.slice(0, -1) : "")
    );

    return data.data;
  };

  /** 프로모션명 리스트 */
  static async promotionNames() {
    const endPoint = "/admin/users/promotion";
    const { data } = await request.get(endPoint);

    return data.data;
  }
}
